import styled from 'styled-components';

export const XMindWrap = styled.div`
  width: 100%;
  height: 100%;

  .page-loading {
    color: var(--Text_Caption);
    font-size: 14px;
    background-color: transparent !important;

    img {
      width: 40px !important;
      height: 40px !important;
      margin-bottom: 12px !important;
    }
  }

  .xMindWrapNoData {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
